<template>
  <Hero :title="data?.header.title" :subtitle="data?.header.subtitle" :narrow="true" :images="data?.header.images"/>
  <main class="main maxw--shoulders mb-2">
    <div class="maxw--waist text--center block">
      <p><i>{{ data?.intro }}</i></p>
    </div>
    <div class="grid--three gap--double">
      <div v-for="sponsor in sponsors" :key="sponsor.id">
        <nuxt-img v-if="sponsor.image" provider="strapi" :src="getStrapiImageLocation(sponsor.image)" class="fit"></nuxt-img>
        <h5 class="mt-2">{{ sponsor.name }}</h5>
        <div class="rendered" v-html="$md.render(sponsor.about || '')"></div>
        <a class="btn btn--flat mt-1" :href="sponsor.link">Meer informatie</a>
      </div>
    </div>
  </main>
</template>

<script lang="ts" setup>
import SponsorsPage from '~/typings/pages/sponsors_page';
import Sponsor from '~/typings/items/sponsor';

const { findOne, find } = useStrapi();

useHead({
  title: 'Sponsoren'
})

const { data } = await useAsyncData(
  'sponsorspage',
  () => findOne<SponsorsPage>('sponsors-page', { populate: ['header', 'header.images'] }),
  {
    transform: flattenStrapiObject
  }
);

const { data: sponsors } = await useAsyncData(
  'sponsors',
  () => find<Sponsor>('sponsors', { populate: ['image'] }),
  {
    transform: flattenStrapiCollection
  }
)
</script>
